/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
 
import { type EnumToUnion } from './types/util';

export const enum FileTypeEnum {
  PDF = 'pdf',
  DOCX = 'docx',
  EXCEL = 'excel',
  CSV = 'csv',
  IMAGE = 'image',
  AUDIO = 'audio',
  VIDEO = 'video',
  ARCHIVE = 'archive',
  CODE = 'code',
  TXT = 'txt',
  PPT = 'ppt',
  DEFAULT_UNKNOWN = 'default_unknown',
}

export type FileType = EnumToUnion<typeof FileTypeEnum>;

export interface TFileTypeConfig {
  fileType: FileTypeEnum;
  accept: string[];
  judge?: (file: Pick<File, 'type'>) => boolean;
}
